<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>
    <md-card>
      <md-card-content>
        <md-layout md-gutter>
          <md-layout md-flex="10">
            <md-button
              class="md-raised md-primary md-button-color md-theme-default back heght-1px"
              @click="previousSalesView"
            >&laquo; Back</md-button>
          </md-layout>
          <md-layout md-flex="30"></md-layout>

          <md-layout md-flex>
            <h2>AMS Filing</h2>
          </md-layout>
        </md-layout>

        <hr class="hr-border">

        <md-layout md-gutter>
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="25">
            <md-layout md-flex="100">
              <label>Master B/L Number</label>
              <b-form-input :formatter="capitalizeAll"
                id="linerBLNumber"
                name="linerBLNumber"
                v-model="amsMainModel.blNumber"
                :disabled="amsMainModel.blType=='liner'"
              ></b-form-input>
            </md-layout>
            <span class="error" v-if="!amsMainModel.blNumber">{{erroramsMainModel.blNumber}}</span>
          </md-layout>
          <md-layout md-flex="10"></md-layout>
          <md-layout md-flex="25">
            <md-input-container>
              <label>Upload B/L</label>
              <md-file
                name="uploadMasterBL"
                id="uploadMasterBL"
                v-model="amsMainModel.uploadMasterBL"
                @selected="onFileChangelinerBL"
                multiple
                :disabled="amsMainModel.blType=='liner'"
              ></md-file>
            </md-input-container>

            <span
              class="error"
              v-if="!amsMainModel.uploadMasterBL"
            >{{erroramsMainModel.uploadMasterBL}}</span>
          </md-layout>
        </md-layout>

        <md-layout md-gutter v-if="uploadBookingStatus.length >0 && amsMainModel.blType=='liner'">
          <md-layout md-flex="40"></md-layout>
          <md-layout md-flex="15" v-for="(item,index) in uploadBookingStatus" :key="index">
            <a
              :href="`${this.docURL}/LinerBLCon/`+item"
              target="_blank"
              download
            >View Document - {{index+1}}</a>
          </md-layout>
        </md-layout>

        <md-layout
          md-gutter
          v-if="uploadBookingStatus.length >0 && amsMainModel.blType=='house' && amsMainModel.amsMainId!=''"
        >
          <md-layout md-flex="35"></md-layout>
          <md-layout md-flex="15" v-for="(item,index) in uploadBookingStatus" :key="index">
            <a
              :href="`${this.docURL}/SeaAwsBL/`+item"
              target="_blank"
              download
            >View Document - {{index+1}}</a>
          </md-layout>
        </md-layout>

        <md-layout md-gutter class="labelMargtop">
          <md-layout md-flex="5"></md-layout>

          <md-layout md-flex="25">
            <label
              for="amsFiling"
            >{{(this.amsMainModel.blType=='liner')?'(Liner-BL)':'(House-BL)'}} AMS Filing To be Done</label>
            <model-list-select
              :list="blTypeList"
              v-model="amsMainModel.amsFiling"
              option-value="blTypeVal"
              option-text="blTypeTxt"
              placeholder="Select AMS Filing "
              :isDisabled="amsTableArry.length>0"
            ></model-list-select>
            <span class="error" v-if="!amsMainModel.amsFiling">{{erroramsMainModel.amsFiling}}</span>
          </md-layout>
          <md-layout md-flex="5"></md-layout>

          <md-layout md-flex="30" v-if="amsMainModel.portLocationType=='USA'" style="margin-top:2%">
            <md-checkbox
              id="my-test5"
              name="my-test5"
              v-model="amsMainModel.isCheckUSA"
              class="md-primary"
              md-value="checked"
            >AMS Against HBL (PRIDEL Fling)</md-checkbox>
          </md-layout>
        </md-layout>

        <hr>

        <md-layout md-gutter v-if="amsMainModel.amsFiling=='Yes'">
          <md-layout md-flex="35"></md-layout>

          <md-layout md-flex="35" v-if="amsMainModel.amsFiling=='Yes'|| amsFiligModal.amsId!=''">
            <h3>
              <u>ADVANCE CARGO DECLARATION(ACD)</u>
            </h3>
          </md-layout>
        </md-layout>
        <md-layout
          md-gutter
          class="labelMargtop"
          v-if="amsMainModel.amsFiling=='Yes'|| amsFiligModal.amsId!=''"
        >
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="35">
            <label for="fclConsoMultipleClientId" v-if="amsFiligModal.amsId==''">Client Name</label>
            <model-list-select
              v-if="amsFiligModal.amsId==''"
              :list="clientList"
              id="fclConsoMultipleClientId"
              v-model="amsFiligModal.fclConsoMultipleClientId"
              option-value="fclConsoMultipleClientId"
              option-text="clientName"
              placeholder="Select  Client Name"
            ></model-list-select>
            <md-layout md-flex="100" v-else>
              <label for="fclConsoMultipleClientId">Client Name</label>

              <b-form-input :formatter="capitalizeAll" v-model="amsFiligModal.clientName" disabled></b-form-input>
            </md-layout>
            <span
              class="error"
              v-if="!amsFiligModal.fclConsoMultipleClientId"
            >{{errorconFclBLNonUsId}}</span>
          </md-layout>
        </md-layout>
        <div v-if="amsMainModel.amsFiling=='Yes' && amsFiligModal.fclConsoMultipleClientId!=''">
          <md-layout md-gutter class="gutr">
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="30">
              <md-layout md-flex="100">
                <label>Vessel Name</label>
                <b-form-input :formatter="capitalizeAll" id="vesselName" name="vesselName" v-model="amsFiligModal.vesselName"></b-form-input>
              </md-layout>
            </md-layout>
            <md-layout md-flex="35"></md-layout>
            <md-layout md-flex="25">
              <md-layout md-flex="100">
                <label>Place of Origin</label>
                <b-form-input :formatter="capitalizeAll"
                  id="placeOrigin"
                  name="placeOrigin"
                  v-model="amsFiligModal.placeOrigin"
                ></b-form-input>
              </md-layout>
            </md-layout>
          </md-layout>
          <md-layout md-gutter class="gutr">
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="30">
              <md-layout md-flex="100">
                <label>Port of Loading</label>
                <b-form-input :formatter="capitalizeAll"
                  id="loadingPort"
                  name="loadingPort"
                  v-model="amsFiligModal.loadingPort"
                ></b-form-input>
              </md-layout>
            </md-layout>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="25">
              <md-layout md-flex="100">
                <label>Port of Discharge</label>
                <b-form-input :formatter="capitalizeAll"
                  id="dischargePort"
                  name="dischargePort"
                  v-model="amsFiligModal.dischargePort"
                ></b-form-input>
              </md-layout>
            </md-layout>

            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="25">
              <md-layout md-flex="100">
                <label>Final Delivery Place With ZIP Code</label>
                <b-form-input :formatter="capitalizeAll"
                  id="finalDeliveryWithZip"
                  name="finalDeliveryWithZip"
                  v-model="amsFiligModal.finalDeliveryWithZip"
                ></b-form-input>
              </md-layout>
            </md-layout>
          </md-layout>
          <md-layout gutter class="labelMargtop">
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="30">
              <label>Actual Shipper Address with Ctc</label>
              <quill-editor
                ref="myTextEditor"
                v-model="amsFiligModal.shipperAddrWithCtc"
                :options="editorOption"
              ></quill-editor>
            </md-layout>
            <md-layout md-flex="5"></md-layout>

            <md-layout md-flex="40">
              <label>Consignee Name Address with Tel.& FAX No.</label>
              <quill-editor
                ref="myTextEditor"
                v-model="amsFiligModal.ConsigneeNameAddrs"
                :options="editorOption"
              ></quill-editor>
            </md-layout>
          </md-layout>
          <md-layout md-gutter class="labelMargtop">
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="25">
              <label>Container No.</label>
              <quill-editor
                ref="myTextEditor"
                v-model="amsFiligModal.containerNo"
                :options="editorOption"
              ></quill-editor>
            </md-layout>
            <md-layout md-flex="10"></md-layout>

            <md-layout md-flex="25">
              <label>Seal No</label>
              <quill-editor
                ref="myTextEditor"
                v-model="amsFiligModal.sealNo"
                :options="editorOption"
              ></quill-editor>
            </md-layout>
          </md-layout>
          <md-layout gutter class="labelMargtop">
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="30">
              <label>Cargo Description With 6 Digit Harmonized Code with No. Of Cartons / Pellets</label>
              <quill-editor
                ref="myTextEditor"
                v-model="amsFiligModal.cargoDescription"
                :options="editorOption"
              ></quill-editor>
            </md-layout>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="30">
              <label>Cargo Gross Weight</label>
              <quill-editor
                ref="myTextEditor"
                v-model="amsFiligModal.cargoGrossWeight"
                :options="editorOption"
              ></quill-editor>
            </md-layout>
            <md-layout md-flex="30">
              <label>Cargo Net Weight</label>
              <quill-editor
                ref="myTextEditor"
                v-model="amsFiligModal.cargoNetWeight"
                :options="editorOption"
              ></quill-editor>
            </md-layout>
          </md-layout>

          <md-layout md-gutter class="labelMargtop">
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="90">
              <label>Declaration</label>
              <quill-editor
                ref="myTextEditor"
                style=" width: 1100px !important"
                v-model="amsFiligModal.declaration"
                :options="editorOption"
              ></quill-editor>
            </md-layout>
          </md-layout>
          <md-layout md-gutter class="labelMargtop">
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="35">
              <md-layout md-flex="100">
                <label>For</label>
                <b-form-input :formatter="capitalizeAll"
                  id="declarationFor"
                  name="declarationFor"
                  v-model="amsFiligModal.declarationFor"
                ></b-form-input>
              </md-layout>
            </md-layout>
            <md-layout md-flex="40"></md-layout>
            <md-layout md-flex="15">
              <label>Date</label>
              <date-picker
              :format="selectDateFormat"
                lang="en"
                id="declarationDate"
                name="declarationDate"
                v-model="amsFiligModal.declarationDate"
              ></date-picker>
            </md-layout>
          </md-layout>
        </div>

        <md-layout md-gutter v-if="amsMainModel.blType=='liner'" class="labelMargtop">
          <md-layout md-flex="5"></md-layout>

          <md-layout md-flex="30">
            <label
              for="isIsfFiling"
            >{{(this.amsMainModel.blType=='liner'?'(Liner-BL)':this.amsMainModel.blType)}} ISF Filing To be Done</label>
            <model-list-select
              :list="blTypeListISF"
              v-model="amsMainModel.isIsfFiling"
              option-value="blTypeIsfVal"
              option-text="blTypeIsfTxt"
              placeholder="Select ISF Filing "
            ></model-list-select>
          </md-layout>
        </md-layout>
        <md-layout md-gutter v-if="amsMainModel.isIsfFiling=='Yes'">
          <md-layout md-flex="5"></md-layout>
        </md-layout>
        <md-layout md-gutter>
          <hr
            class="hr-border"
            v-if="amsMainModel.amsFiling=='Yes' && clientList.length>0 || amsFiligModal.amsId!=''"
          >
          <md-layout md-flex="40"></md-layout>
          <md-layout md-flex="20">
            <md-button
              class="md-raised md-primary md-button-color md-theme-default back heght-1px"
              id="addButtonLoaderSubmit"
              @click="addAms('')"
            >Submit</md-button>
            <md-spinner md-indeterminate id="loaderSubmit" style="display:none"></md-spinner>
          </md-layout>
        </md-layout>

        <hr class="hr-s">
        <div class="box" v-if="amsTableArry.length>0">
          <div class="box-header">
            <h3 class="box-title">AMS Details</h3>
          </div>
          <hr class="hr-s">

          <div class="box-body">
            <table id="clientSB" class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>Sr No.</th>
                  <th>Client Name</th>

                  <th>Print</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item,index) in amsTableArry" :key="index">
                  <td>{{index+1}}</td>
                  <td class="showMoreData" @click="viewEditAms(item)">{{item.clientName}}</td>

                  <td>
                    <md-button
                      class="md-icon-button md-raised md-dense"
                      @click="Print(item.uploadACDCON)"
                    >
                      <md-icon>print</md-icon>
                    </md-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <md-layout md-gutter>
          <md-layout md-flex="70"></md-layout>

          <md-layout
            md-flex="25"
            v-if="(amsMainModel.portLocationType=='USA' && amsMainModel.blType=='house') || amsMainModel.isIsfFiling=='Yes'"
          >
            <md-button
              class="md-raised md-primary md-button-color md-theme-default back heght-1px"
              id="addButtonLoaderIFS"
              @click="addAms('fdf')"
            >Proceed To IFS Form</md-button>
            <md-spinner md-indeterminate id="loaderIFS" style="display:none"></md-spinner>
          </md-layout>
        </md-layout>
      </md-card-content>
    </md-card>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPopBL"
      @close="oncloseBL"
    ></md-dialog-alert>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPopError"></md-dialog-alert>
    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" ref="addPop6"></md-dialog-confirm>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";

export default {
  beforeMount() {
    if (globalPermissionStatus("Sea Freight")) {
      this.$store.dispatch("setCurrentRoute", "/ffExportCon/conAmsFilling");
      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard"
      });
    }
  },
  data() {
    return {
      selectDateFormat,
      docURL: URL_BASE_DOC,
      editorOption: {
        modules: {}
      },
      editorContent: "",
      isLoading: false,

      blTypeList: [
        {
          blTypeVal: "Yes",
          blTypeTxt: "Yes"
        },
        {
          blTypeVal: "No",
          blTypeTxt: "No"
        }
      ],
      blTypeListISF: [
        {
          blTypeIsfVal: "Yes",
          blTypeIsfTxt: "Yes"
        },
        {
          blTypeIsfVal: "No",
          blTypeIsfTxt: "No"
        }
      ],

      alert: {
        content: "Added Succesfully",
        ok: "ok"
      },
      getCLientData: [],
      getContainerArry: [],
      amsTableArry: [],
      mainExportData: [],

      amsFiligModal: {
        amsId: "",
        fclConsoMultipleClientId: "",

        clientName: "",
        vesselName: "",
        placeOrigin: "",
        loadingPort: "",
        dischargePort: "",
        finalDeliveryWithZip: "",
        shipperAddrWithCtc: "",
        ConsigneeNameAddrs: "",
        cargoDescription: "",
        cargoGrossWeight: "",
        cargoNetWeight: "",
        containerNo: "",
        sealNo: "",
        declaration:
          "We hereby indemnify the carrier Mediterranean Shipping Company on any claims / loss for any misdeclaration of the above information and all costs and consequences arising out of the shipment is on our (shipper's) account.",
        declarationFor: "",
        declarationDate: ""
      },
      erroramsMainModel: {
        blNumber: "",
        uploadMasterBL: "",
        amsFiling: ""
      },

      arrayErroramsMainModel: {
        blNumber: "Enter BL Number",
        uploadMasterBL: "Upload Master BL",
        amsFiling: "Select Ams Filing"
      },
      errorconFclBLNonUsId: "",
      amsMainModel: {
        amsMainId: "",
        portLocationType: "",
        blNumber: "",
        uploadMasterBL: "",
        blType: this.$sessionsStorage.get("blType"),
        ffType: "fclCon",
        isCheckUSA: "",

        amsFiling: "",
        ExportId: "",
        ExecutionId: "",
        BookingId: "",
        isIsfFiling: ""
      },

      validate: true
    };
  },

  filters: {
    moment(date) {
      return DateFormat(date)
    }
  },
  watch: {
    amsFiligModal: {
      handler: function(newVal, oldVal) {
        console.log("Here Change obj", newVal, oldVal);

        if (
          this.amsFiligModal.fclConsoMultipleClientId != "" &&
          this.amsFiligModal.amsId == "" &&
          this.amsMainModel.blType == "house"
        ) {
          let checkAlready = this.amsTableArry.filter(x => {
            return (
              x.fclConsoMultipleClientId ==
              this.amsFiligModal.fclConsoMultipleClientId
            );
          });

          if (checkAlready.length > 0 && this.amsFiligModal.amsId == "") {
            this.alert.content = checkAlready[0].clientName + " Already Exist";
            this.$refs["addPopError"].open();
            this.amsFiligModal.fclConsoMultipleClientId = "";
          } else {
            let arrayClentId = this.getCLientData.filter(x => {
              return (
                x.fclConsoMultipleClientId ==
                this.amsFiligModal.fclConsoMultipleClientId
              );
            });

            if (arrayClentId.length > 0) {
              this.amsFiligModal.clientName = arrayClentId[0].clientName;
              this.amsFiligModal.shipperAddrWithCtc = arrayClentId[0].consignor;
              this.amsFiligModal.ConsigneeNameAddrs = arrayClentId[0].consignee;
              this.amsFiligModal.cargoGrossWeight = arrayClentId[0].grossWeight;
              this.amsFiligModal.cargoNetWeight = arrayClentId[0].netWeight;
              this.amsFiligModal.loadingPort = arrayClentId[0].portLoad;
              this.amsFiligModal.finalDeliveryWithZip =
                arrayClentId[0].placeDilievery;
              this.amsFiligModal.dischargePort = arrayClentId[0].portDischarge;
            }

            let arrayContainer = this.getContainerArry.filter(x => {
              return x.ffConExecutionId == arrayClentId[0].ffConExecutionId;
            });
          }
        }

        if (
          this.amsFiligModal.fclConsoMultipleClientId != "" &&
          this.amsFiligModal.amsId == "" &&
          this.amsMainModel.blType == "liner"
        ) {
          let checkAlready = this.amsTableArry.filter(x => {
            return (
              x.fclConsoMultipleClientId ==
              this.amsFiligModal.fclConsoMultipleClientId
            );
          });

          if (checkAlready.length > 0 && this.amsFiligModal.amsId == "") {
            this.alert.content = checkAlready[0].clientName + " Already Exist";
            this.$refs["addPopError"].open();
            this.amsFiligModal.fclConsoMultipleClientId = "";
          } else {
            let arrayClentId = this.getCLientData.filter(x => {
              return (
                x.fclConsoMultipleClientId ==
                this.amsFiligModal.fclConsoMultipleClientId
              );
            });

            if (arrayClentId.length > 0) {
              let arrayNew = this.mainExportData.filter(x => {
                return (
                  x.ffFclConsoExportId == arrayClentId[0].ffFclConsoExportId
                );
              });
              this.amsFiligModal.clientName = arrayClentId[0].clientName;

              if (arrayNew.length > 0) {
                this.amsFiligModal.shipperAddrWithCtc =
                  "<p>" +
                  arrayClentId[0].clientName +
                  "</p><p>" +
                  arrayClentId[0].corporateAddress +
                  "</p>";
                this.amsFiligModal.loadingPort = arrayNew[0].valLP;

                this.amsFiligModal.finalDeliveryWithZip = arrayNew[0].valFinal;
                this.amsFiligModal.dischargePort = arrayNew[0].valPodLocation;

                let arrayContainer = this.getContainerArry.filter(x => {
                  return (
                    x.ffFclConsoExportId == arrayClentId[0].ffFclConsoExportId
                  );
                });

                // console.log(this.getContainerArry, arrayClentId, "fdsfds");

                if (arrayContainer.length > 0) {
                  this.amsFiligModal.containerNo =
                    arrayContainer[0].fclConcontainerNo;
                  this.amsFiligModal.sealNo = arrayContainer[0].customSealNo;
                  this.amsFiligModal.cargoGrossWeight =
                    arrayContainer[0].conGrossWeight;
                }
              }
            }
          }
        }
      },

      deep: true
    }
  },
  mounted() {},

  beforeDestroy() {},

  destroyed() {},

  components: {
    DatePicker,
    ModelListSelect,
    // Loading
    CustomLoader,
  },

  computed: {
    uploadBookingStatus() {
      return this.amsMainModel.uploadMasterBL != ""
        ? this.amsMainModel.uploadMasterBL.split(",")
        : [];
    },
    clientList() {
      return this.getCLientData;
    }
  },

  methods: {
    Print(item) {
      window.open(`${URL_BASE}/ConFFACD/` + item);
    },
    doLoading() {
      this.isLoading = true;
      // simulate AJAX
    },
    doLoadingClose() {
      this.isLoading = true;
      // simulate AJAX
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    oncloseBL() {},
    getData() {
      this.doLoading();
      let new_data = {
        blType: this.$sessionsStorage.get("blType")
      };

      new_data["ffFclConsoExportId"] = this.$sessionsStorage.get(
        "editffFclConsoExportId"
      );
      new_data["ffConExecutionId"] = this.$sessionsStorage.get(
        "editffConExecutionId"
      );

      // console.log(new_data);

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaExport/GetDataAmsFiling.php`,
        data: JSON.stringify(new_data),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };
      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            console.log(data);

            if (data.ConBLNonUsData.length > 0) {
              this.getCLientData = data.ConBLNonUsData;
            } else {
              this.getCLientData = [];
            }

            if (data.stuffingData.length > 0) {
              this.amsMainModel.portLocationType =
                data.stuffingData[0].portLocationType;
            }

            if (data.ConBLNonUsData.length > 0) {
              this.getContainerArry = data.containerData;
            } else {
              this.getContainerArry = [];
            }
            if (data.amsMainData.length > 0) {
              Object.keys(this.amsMainModel).map(x => {
                this.amsMainModel[x] = data.amsMainData[0][x] || "";
              });
            } else {
              if (data.blLandingData.length > 0) {
                this.amsMainModel.uploadMasterBL =
                  data.blLandingData[0].linerBLupload;
                this.amsMainModel.blNumber =
                  data.blLandingData[0].linerBLNumber;
              }
            }
            if (data.amsData.length > 0) {
              this.amsTableArry = data.amsData;
            }

            if (data.stuffingData.length > 0) {
              this.mainExportData = data.stuffingData;
            }
            this.doLoadingClose();
            this.JqueryFun();
          }
        })
        .catch(error => {});
    },
    onFileChangelinerBL() {
      var files = event.target.files || event.dataTransfer.files;

      var formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("file[]", files[i]);
      }
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Authorization: this.$sessionsStorage.get("editExportFCLId")
        }
      };

      axios
        .post(`${URL_BASE}/Api_FFSeaExport/UploadFFBooking.php`, formData, config)
        .then(result => {
          this.amsMainModel.uploadMasterBL = result.data;
          // console.log("fdsf", result.data);
        })
        .catch(err => {
          throw err;
        });
    },

    viewEditAms(item) {
      // let arrayFilterAms = this.amsTableArry.filter(x => {
      //   return x.amsId == item.amsId;
      // });
      Object.keys(this.amsFiligModal).map((x, index) => {
        this.amsFiligModal[x] = item[x];
      });
    },

    validateAms() {
      let validate_new = true;
      Object.keys(this.erroramsMainModel).map((x, index) => {
        if (this.amsMainModel[x] == "") {
          this.erroramsMainModel[x] = this.arrayErroramsMainModel[x];
          validate_new = false;
        }
      });

      if (validate_new == true) {
        this.validate = true;
      } else {
        this.validate = false;
      }
    },
    addAms(id) {
      this.amsMainModel["ExportId"] = this.$sessionsStorage.get(
        "editffFclConsoExportId"
      );
      this.amsMainModel["ExecutionId"] = this.$sessionsStorage.get(
        "editffConExecutionId"
      );
      this.amsMainModel["BookingId"] = this.$sessionsStorage.get(
        "editconFclBookingId"
      );

      let new_data = {
        amsMainModel: this.amsMainModel
      };

      if (id == "") {
        new_data["onlyExecMain"] = "";
      } else {
        new_data["onlyExecMain"] = "fczdfs";
      }

      if (this.amsMainModel.amsFiling == "Yes") {
        // if (
        //   this.amsFiligModal.fclConsoMultipleClientId == "" &&
        //   this.getCLientData.length > 0
        // ) {
        //   window.scroll(0, 100);
        //   this.errorconFclBLNonUsId = "Select Client Id";
        //   return false;
        // } else {
        //   this.errorconFclBLNonUsId = "";
        // }

        new_data["amsFiligModal"] = this.amsFiligModal;
      }

      this.validateAms();

      //  this.validateBLRaised();

      if (this.validate != false) {
        $("#addButtonLoader").css("display", "none");
        $("#loader").css("display", "block");
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaExport/addAmsFFiling.php`,
          data: JSON.stringify(new_data),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };
        axios(options)
          .then(result => {
            const { statusText, status, data } = result;
            if ( status == 200 && data) {
              $("#loader").css("display", "none");
              $("#addButtonLoader").css("display", "block");

              if (this.amsFiligModal.amsId != "") {
                this.alert.content = "Data updated Successfully";
                this.$refs["addPop"].open();
              } else {
                this.alert.content = "Data Added Successfully";
              }

              if (id != "") {
                this.$router.push({
                  path: "/ffExportCon/isfForm"
                });
              }

              Object.keys(this.amsFiligModal).map(x => {
                this.amsFiligModal[x] = "";
              });

              this.getData();
              this.JqueryFun();
            }
          })
          .catch(error => {});
      }
    },

    previousSalesView() {
      // /ffExportCon/conFclBLofLanding
      // /ffExportCon/conBLUs

      if (
        this.$sessionsStorage.get("blType") == "house" &&
        this.amsMainModel.portLocationType == "USA"
      ) {
        this.$router.push({
          path: "/ffExportCon/conBLSlineUs"
        });
      } else if (
        this.$sessionsStorage.get("blType") == "house" &&
        this.amsMainModel.portLocationType == "NON_USA"
      ) {
        this.$router.push({
          path: "/ffExportCon/conBLNewNonUs"
        });
      } else {
        this.$router.push({
          path: "/ffExportCon/conFclBLofLanding"
        });
      }
    }
  }
};
</script>

<style>
.md-direction-bottom-right {
  width: 30% !important;
}
.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 0px;
}
.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}
.md-button-color {
  background-color: #607d8d !important;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>


// WEBPACK FOOTER //
// amsFilling.vue?050347b2